import { PredefinedAlerts } from "@station/domain/models/predefined-alert.model";
import type { AlertRepository } from "@station/domain/repositories/alert.repository";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class PredefinedAlertGetAllUseCase {
    constructor(
        @inject(stationsTypes.repositories.AlertRepository)
        private readonly alertRepository: AlertRepository,
    ) {}

    async execute(stationId: string): Promise<PredefinedAlerts> {
        const predefinedAlertResult =
            await this.alertRepository.getAllPredefinedAlert(stationId);

        return predefinedAlertResult.match(
            (predefinedAlerts) => predefinedAlerts,
            () => PredefinedAlerts.empty(),
        );
    }
}
